import InfoManager from './InfoManager';

export default InfoManager;
